module.exports = {
    CITY: 'CITY',
    CITIES: 'CITIES',
    RECEIVE_CITY_CEDEX: 'RECEIVE_CITY_CEDEX',
    RESET_CITY: 'RESET_CITY',
    RECEIVE_CITY_CENTERS: 'RECEIVE_CITY_CENTERS',
    RECEIVE_COUNTRIES: 'RECEIVE_COUNTRIES',
    RECEIVE_CITIES_HISTO: 'RECEIVE_CITIES_HISTO'
}